import DashBoardNav from '@/layout/DashBoardNav'

export default [{
  path: '/purchaseflow',
  component: DashBoardNav,
  children: [
    {
      name: '/flow-sources',
      path: '/flow-sources',
      component: () => import('@/components/purchaseflow/FlowSources'),
      props: true
    },
    {
      name: 'flow-filter',
      path: '/flow-filter',
      component: () => import('@/components/purchaseflow/FlowFilter'),
      props: true
    },
    {
      name: 'flow-columns',
      path: '/flow-columns',
      component: () => import('@/components/purchaseflow/FlowColumns'),
      props: true
    },
    {
      name: 'flow-review',
      path: '/flow-review',
      component: () => import('@/components/purchaseflow/FlowReview'),
      props: true
    }
  ]
}]
